import { render, staticRenderFns } from "./risk_type.vue?vue&type=template&id=f61f2a34&scoped=true"
import script from "./risk_type.vue?vue&type=script&lang=js"
export * from "./risk_type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61f2a34",
  null
  
)

export default component.exports